import { render, staticRenderFns } from "./ExpertVisits.vue?vue&type=template&id=252e36c4&"
import script from "./ExpertVisits.vue?vue&type=script&lang=js&"
export * from "./ExpertVisits.vue?vue&type=script&lang=js&"
import style0 from "./ExpertVisits.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports